import React from 'react';
import ReactDOM from 'react-dom/client';
import DealRoomApplication from './app';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <DealRoomApplication />
  </React.StrictMode>
);
